import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
  selector: 'limitlabelmodal',
  styleUrls: ['./limitlabelmodal.component.scss'],
  templateUrl: './limitlabelmodal.component.html'
})
export class LimitlabelmodalComponent {
  Label: any;
  @Input() cModal: any = {};
  @Output() onBtnSelection = new EventEmitter<any>();
  modalAddHandler(btnOutput: any) {
    this.onBtnSelection.emit(btnOutput);
    this.cModal.state = false;
    this.Label = "";
  }
}




// WEBPACK FOOTER //
// ./src/app/limits/limitlabelmodal.component.ts